<template>
  <div id="npe-app">
    <v-app>
      <v-main class="mb-6">
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>

      <v-footer class="blue-grey lighten-5 text-caption py-6">
        <v-layout justify-start align-center fill-height>
          <v-sheet
            color="transparent"
            class="d-flex flex-md-row flex-column justify-space-between mx-auto"
            width="968"
            max-width="968"
          >
            <div>
              <v-sheet color="transparent" class="blue-grey--text text--darken-2">
                &copy;{{ year }} WisePay - All Rights Reserved
              </v-sheet>
            </div>
            <div>
              <v-sheet color="transparent" class="d-flex flex-wrap justify-space-around">
                <div class="d-flex flex-grow-1 justify-space-between">
                  <a
                    href="https://wisesync.link/app_FooterTerms"
                    target="_blank"
                    class="pr-2 blue-grey--text text--darken-1"
                  >
                    Terms
                  </a>
                  <a
                    href="https://wisesync.link/app_FooterPrivacy"
                    target="_blank"
                    class="px-2 blue-grey--text text--darken-1"
                  >
                    Privacy
                  </a>
                  <a
                    href="https://wisesync.link/app_FooterCompliance"
                    target="_blank"
                    class="pl-2 pr-0 pr-sm-2 blue-grey--text text--darken-1"
                  >
                    Compliance
                  </a>
                </div>
                <div class="d-flex flex-grow-1 justify-space-between">
                  <a
                    href="https://connectwise20.my.site.com/serviceandsupport/s/contactsupport?n=1"
                    target="_blank"
                    class="pl-0 pr-2 pl-md-2 blue-grey--text text--darken-1"
                  >
                    Payer Support
                  </a>
                  <a
                    href="https://wisesync.link/app_FooterWPWebsite"
                    target="_blank"
                    class="px-2 blue-grey--text text--darken-1"
                  >
                    Website
                  </a>
                  <a
                    href="https://docs.connectwise.com/Wise-Sync/095/WisePay_Release_Notes"
                    target="_blank"
                    class="pl-2 blue-grey--text text--darken-1"
                  >
                    Release Notes
                  </a>
                  <div class="pl-2 blue-grey--text text--darken-1">v{{ versionPrefix }}</div>
                </div>
              </v-sheet>
            </div>
          </v-sheet>
        </v-layout>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: process.env.VUE_APP_YEAR,
      versionPrefix: process.env.VUE_APP_VERSION,
    };
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
